<template>
	<div>
		<BaseAccordionController :accordion_header="getStateWithParam('rlt_label')" :expand_accondion="true">
			<template v-slot:component>
				<GoogleMapsTraffic @mapready="handleMapReady" />
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import GoogleMapsTraffic from '@/components/traffic/GoogleMapsTraffic';

export default {
	name: 'TraficMap',
	components: {
		GoogleMapsTraffic,
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		handleMapReady(){
			this.$store.state.active_loader = false;
		}
	},
	data() {
		return {
			data_map: [],
			from_where: 5,
			expand_accondion: true,
			icon_url: require('@/assets/img/new_icons/kamera.svg'),
		};
	},
};
</script>

<style lang="scss" scoped src="./TraficMap.scss"></style>
